import { DateTime } from 'luxon';

export function checkIfWithinWorkingHours(workStart = '11:00', workEnd = '21:00'): boolean {
    const now = DateTime.local();

    const [startHour, startMinute] = workStart.split(':').map(Number);
    const [endHour, endMinute] = workEnd.split(':').map(Number);

    const startTime = now.set({ hour: startHour, minute: startMinute, second: 0, millisecond: 0 });
    const endTime = now.set({ hour: endHour, minute: endMinute, second: 0, millisecond: 0 });

    return now >= startTime && now <= endTime;
}
